export default {
  MALE: 1,
  FEMALE: 2,
};
